const publicUrl = process.env.PUBLIC_URL || ''
const sightseeingAsset = (file) => `${publicUrl}/sightseeing/${file}`

const data = {
  category: [
    {
      name: '🎌 Flags',
      value: 'flags',
    },
    {
      name: '🧳 Travel',
      value: 'travel-and-places',
    },
  ],
  flagCountries: [
    { code: 'ae', name: 'United Arab Emirates', capital: 'Abu Dhabi' },
    { code: 'ar', name: 'Argentina', capital: 'Buenos Aires' },
    { code: 'at', name: 'Austria', capital: 'Vienna' },
    { code: 'au', name: 'Australia', capital: 'Canberra' },
    { code: 'az', name: 'Azerbaijan', capital: 'Baku' },
    { code: 'ba', name: 'Bosnia and Herzegovina', capital: 'Sarajevo' },
    { code: 'bb', name: 'Barbados', capital: 'Bridgetown' },
    { code: 'bd', name: 'Bangladesh', capital: 'Dhaka' },
    { code: 'be', name: 'Belgium', capital: 'Brussels' },
    { code: 'bg', name: 'Bulgaria', capital: 'Sofia' },
    { code: 'bh', name: 'Bahrain', capital: 'Manama' },
    { code: 'bo', name: 'Bolivia', capital: 'La Paz' },
    { code: 'br', name: 'Brazil', capital: 'Brasília' },
    { code: 'bt', name: 'Bhutan', capital: 'Thimphu' },
    { code: 'bw', name: 'Botswana', capital: 'Gaborone' },
    { code: 'by', name: 'Belarus', capital: 'Minsk' },
    { code: 'ca', name: 'Canada', capital: 'Ottawa' },
    { code: 'ch', name: 'Switzerland', capital: 'Bern' },
    { code: 'cl', name: 'Chile', capital: 'Santiago' },
    { code: 'cn', name: 'China', capital: 'Beijing' },
    { code: 'co', name: 'Colombia', capital: 'Bogotá' },
    { code: 'cr', name: 'Costa Rica', capital: 'San José' },
    { code: 'cu', name: 'Cuba', capital: 'Havana' },
    { code: 'cz', name: 'Czechia', capital: 'Prague' },
    { code: 'de', name: 'Germany', capital: 'Berlin' },
    { code: 'dk', name: 'Denmark', capital: 'Copenhagen' },
    { code: 'do', name: 'Dominican Republic', capital: 'Santo Domingo' },
    { code: 'dz', name: 'Algeria', capital: 'Algiers' },
    { code: 'ec', name: 'Ecuador', capital: 'Quito' },
    { code: 'ee', name: 'Estonia', capital: 'Tallinn' },
    { code: 'eg', name: 'Egypt', capital: 'Cairo' },
    { code: 'es', name: 'Spain', capital: 'Madrid' },
    { code: 'fi', name: 'Finland', capital: 'Helsinki' },
    { code: 'fr', name: 'France', capital: 'Paris' },
    { code: 'gb', name: 'United Kingdom', capital: 'London' },
    { code: 'ge', name: 'Georgia', capital: 'Tbilisi' },
    { code: 'gh', name: 'Ghana', capital: 'Accra' },
    { code: 'gr', name: 'Greece', capital: 'Athens' },
    { code: 'gt', name: 'Guatemala', capital: 'Guatemala City' },
    { code: 'hk', name: 'Hong Kong', capital: 'Hong Kong' },
    { code: 'hr', name: 'Croatia', capital: 'Zagreb' },
    { code: 'hu', name: 'Hungary', capital: 'Budapest' },
    { code: 'id', name: 'Indonesia', capital: 'Jakarta' },
    { code: 'ie', name: 'Ireland', capital: 'Dublin' },
    { code: 'il', name: 'Israel', capital: 'Jerusalem' },
    { code: 'in', name: 'India', capital: 'New Delhi' },
    { code: 'iq', name: 'Iraq', capital: 'Baghdad' },
    { code: 'ir', name: 'Iran', capital: 'Tehran' },
    { code: 'is', name: 'Iceland', capital: 'Reykjavík' },
    { code: 'it', name: 'Italy', capital: 'Rome' },
    { code: 'jm', name: 'Jamaica', capital: 'Kingston' },
    { code: 'jo', name: 'Jordan', capital: 'Amman' },
    { code: 'jp', name: 'Japan', capital: 'Tokyo' },
    { code: 'ke', name: 'Kenya', capital: 'Nairobi' },
    { code: 'kg', name: 'Kyrgyzstan', capital: 'Bishkek' },
    { code: 'kh', name: 'Cambodia', capital: 'Phnom Penh' },
    { code: 'kr', name: 'South Korea', capital: 'Seoul' },
    { code: 'kw', name: 'Kuwait', capital: 'Kuwait City' },
    { code: 'kz', name: 'Kazakhstan', capital: 'Astana' },
    { code: 'la', name: 'Laos', capital: 'Vientiane' },
    { code: 'lb', name: 'Lebanon', capital: 'Beirut' },
    { code: 'lk', name: 'Sri Lanka', capital: 'Colombo' },
    { code: 'lt', name: 'Lithuania', capital: 'Vilnius' },
    { code: 'lu', name: 'Luxembourg', capital: 'Luxembourg' },
    { code: 'lv', name: 'Latvia', capital: 'Riga' },
    { code: 'ma', name: 'Morocco', capital: 'Rabat' },
    { code: 'md', name: 'Moldova', capital: 'Chișinău' },
    { code: 'me', name: 'Montenegro', capital: 'Podgorica' },
    { code: 'mk', name: 'North Macedonia', capital: 'Skopje' },
    { code: 'mn', name: 'Mongolia', capital: 'Ulaanbaatar' },
    { code: 'mt', name: 'Malta', capital: 'Valletta' },
    { code: 'mx', name: 'Mexico', capital: 'Mexico City' },
    { code: 'my', name: 'Malaysia', capital: 'Kuala Lumpur' },
    { code: 'ng', name: 'Nigeria', capital: 'Abuja' },
    { code: 'nl', name: 'Netherlands', capital: 'Amsterdam' },
    { code: 'no', name: 'Norway', capital: 'Oslo' },
    { code: 'np', name: 'Nepal', capital: 'Kathmandu' },
    { code: 'nz', name: 'New Zealand', capital: 'Wellington' },
    { code: 'om', name: 'Oman', capital: 'Muscat' },
    { code: 'pa', name: 'Panama', capital: 'Panama City' },
    { code: 'pe', name: 'Peru', capital: 'Lima' },
    { code: 'ph', name: 'Philippines', capital: 'Manila' },
    { code: 'pk', name: 'Pakistan', capital: 'Islamabad' },
    { code: 'pl', name: 'Poland', capital: 'Warsaw' },
    { code: 'pt', name: 'Portugal', capital: 'Lisbon' },
    { code: 'py', name: 'Paraguay', capital: 'Asunción' },
    { code: 'qa', name: 'Qatar', capital: 'Doha' },
    { code: 'ro', name: 'Romania', capital: 'Bucharest' },
    { code: 'rs', name: 'Serbia', capital: 'Belgrade' },
    { code: 'ru', name: 'Russia', capital: 'Moscow' },
    { code: 'sa', name: 'Saudi Arabia', capital: 'Riyadh' },
    { code: 'se', name: 'Sweden', capital: 'Stockholm' },
    { code: 'sg', name: 'Singapore', capital: 'Singapore' },
    { code: 'si', name: 'Slovenia', capital: 'Ljubljana' },
    { code: 'sk', name: 'Slovakia', capital: 'Bratislava' },
    { code: 'th', name: 'Thailand', capital: 'Bangkok' },
    { code: 'tn', name: 'Tunisia', capital: 'Tunis' },
    { code: 'tr', name: 'Turkey', capital: 'Ankara' },
    { code: 'tw', name: 'Taiwan', capital: 'Taipei' },
    { code: 'ua', name: 'Ukraine', capital: 'Kyiv' },
    { code: 'us', name: 'United States', capital: 'Washington, D.C.' },
    { code: 'uy', name: 'Uruguay', capital: 'Montevideo' },
    { code: 'uz', name: 'Uzbekistan', capital: 'Tashkent' },
    { code: 've', name: 'Venezuela', capital: 'Caracas' },
    { code: 'vn', name: 'Vietnam', capital: 'Hanoi' },
    { code: 'za', name: 'South Africa', capital: 'Pretoria' },
  ],
  /** Landmark photos in public/sightseeing/ (see LICENSES.txt); match pairs by landmark name, label shows city. */
  sightseeing: [
    {
      landmark: 'Eiffel Tower',
      city: 'Paris',
      image: sightseeingAsset('eiffel-paris.jpg'),
    },
    {
      landmark: 'Colosseum',
      city: 'Rome',
      image: sightseeingAsset('colosseum-rome.jpg'),
    },
    {
      landmark: 'Pantheon',
      city: 'Rome',
      image: sightseeingAsset('pantheon-rome.jpg'),
    },
    {
      landmark: 'Elizabeth Tower (Big Ben)',
      city: 'London',
      image: sightseeingAsset('big-ben-london.jpg'),
    },
    {
      landmark: 'Statue of Liberty',
      city: 'New York',
      image: sightseeingAsset('statue-liberty-nyc.jpg'),
    },
    {
      landmark: 'Sydney Opera House',
      city: 'Sydney',
      image: sightseeingAsset('opera-sydney.jpg'),
    },
    {
      landmark: 'Taj Mahal',
      city: 'Agra',
      image: sightseeingAsset('taj-agra.jpg'),
    },
    {
      landmark: 'Christ the Redeemer',
      city: 'Rio de Janeiro',
      image: sightseeingAsset('christ-rio.jpg'),
    },
    {
      landmark: 'Sagrada Família',
      city: 'Barcelona',
      image: sightseeingAsset('sagrada-barcelona.jpg'),
    },
    {
      landmark: 'Golden Gate Bridge',
      city: 'San Francisco',
      image: sightseeingAsset('golden-gate-sf.jpg'),
    },
    {
      landmark: 'Acropolis (Parthenon)',
      city: 'Athens',
      image: sightseeingAsset('parthenon-athens.jpg'),
    },
    {
      landmark: 'Petra (Al-Khazneh)',
      city: 'Petra',
      image: sightseeingAsset('petra-treasury.jpg'),
    },
  ],
  pairs: [
    {
      value: 4,
      name: "Easy (8 cards)",
    },
    {
      value: 6,
      name: "Medium (12 cards)",
    },
    {
      value: 8,
      name: "Expert (16 cards)",
    },
    {
      value: 10,
      name: "Master (20 cards)",
    },
  ],
}

export { data }